export default __webpack_public_path__ + "static/media/Roboto-Italic.801622d3.ttf";